package music.limasoul.client.shared.navigation

import kotlinx.serialization.Serializable

sealed class Navigation {

    @Serializable
    data object Login : Navigation()

    @Serializable
    data object Profile : Navigation()

    @Serializable
    data class ProfileUser(val id: Long) : Navigation()

    @Serializable
    data object Admin : Navigation()

    object Event {

        @Serializable
        data object List : Navigation()

        @Serializable
        data object Create : Navigation()

        @Serializable
        data class Details(val id: Long) : Navigation()

        @Serializable
        data class Edit(val id: Long) : Navigation()

        @Serializable
        data class Freeze(val id: Long) : Navigation()
    }

    object EventTrack {

        @Serializable
        data class Create(val eventId: Long) : Navigation()

        @Serializable
        data class Details(val eventId: Long, val trackId: Long) : Navigation()

        @Serializable
        data class MemberDialog(val extended: Boolean) : Navigation()
    }
}

fun createTelegramUrl(userName: String): String {
    val formatted = userName.replace("@", "")
    return "https://t.me/$formatted"
}